import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { OrderDetailPageInitialData } from "./orderDetailPageInitialData";

const ORDER_DETAIL_PAGE_ID = "my-account/order";
const ACCOUNT_SWITCH_QUERY_ALIASES = {
  account: "targetAccount",
  salesOrg: "targetSalesOrg",
} as const;

export interface OrderDetailPageSearch {
  id?: string;
  account?: string;
  salesOrg?: string;
}

function buildPath(search: OrderDetailPageSearch): string {
  const params = new URLSearchParams();
  if (search.id !== undefined) {
    params.set("id", search.id);
  }
  if (search.account !== undefined) {
    params.set("account", search.account);
  }
  if (search.salesOrg !== undefined) {
    params.set("salesOrg", search.salesOrg);
  }
  const query = params.toString();
  return `${ORDER_DETAIL_PAGE_ID}${query ? `?${query}` : ""}`;
}

export const orderDetailPageQueryOptions = (search: OrderDetailPageSearch = {}) =>
  queryOptions({
    queryKey: pageDataKeys.pageWithInputs("orders-detail", search),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<OrderDetailPageInitialData>>(`/page-data/${buildPath(search)}`, {
        queryParamAliases: ACCOUNT_SWITCH_QUERY_ALIASES,
      }),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
